'use strict';

var _ = require('lodash');
var MarketAnalysisDemandAdjustmentItemController = function MarketAnalysisDemandAdjustmentItemController($scope, $rootScope, featureToggleService, transitionDataService, serviceShareDataProviderService, dataLoaderPanelConstants, distributeUserValueService, effectiveValueCalculator, userSecureService) {
  $scope.compareMode = false;
  $scope.dataStatus = dataLoaderPanelConstants.LOADING;
  $scope.viewOnlyPermissions = !userSecureService.hasAuthorization('market-analysis', 'write');
  function basicModeState() {
    $scope.compareMode = false;
    $scope.chartInCompareMode = null;
  }
  function resetScope() {
    $scope.view.disabled = false;
    $scope.groupShareData = undefined;
    $scope.serviceShare = undefined;
    $scope.originalGroupShareUserData = undefined;
  }
  function disableTabForData(shareData) {
    return $scope.hideItemIfSingleModelValue && !_.isUndefined(shareData.groupShare) && _.size(shareData.groupShare.model) < 2;
  }
  $scope.getServiceShareData = function () {
    serviceShareDataProviderService.retrieveData($scope.filterData, $scope.chartId).then(function (shareData) {
      resetScope();
      if (disableTabForData(shareData)) {
        $scope.view.disabled = true;
      } else if (shareData) {
        $scope.groupShareData = shareData.groupShare;
        $scope.serviceShare = shareData.serviceShare;
        $scope.originalGroupShareUserData = _.cloneDeep($scope.groupShareData.user);
        $scope.dataStatus = dataLoaderPanelConstants.LOADED;
        adjustButtonsAvailability();
      } else {
        $scope.dataStatus = dataLoaderPanelConstants.NOT_FOUND;
      }
    }, function () {
      resetScope();
      $scope.dataStatus = dataLoaderPanelConstants.ERROR;
    });
  };
  $scope.getServiceShareData();
  $scope.dataLoaded = function () {
    return $scope.dataStatus === dataLoaderPanelConstants.LOADED;
  };
  function clearChartInCompareMode() {
    if ($scope.compareMode) {
      basicModeState();
    }
  }
  $scope.resetUserAdjustments = function () {
    clearChartInCompareMode();
    $scope.compareGroupShareUserData = undefined;
    $scope.groupShareData.user = _.cloneDeep($scope.originalGroupShareUserData);
    adjustButtonsAvailability();
  };
  $scope.isUserData = function (propertyName) {
    return propertyName === 'user';
  };
  $scope.isUserInputDisabled = function (propertyName) {
    return !$scope.isUserData(propertyName) || $scope.isOtherChartInCompareMode($scope.chartId);
  };
  $scope.onCancelClick = function () {
    basicModeState();
    closeDrawer();
  };
  function fieldsToModify() {
    var mappedMode = featureToggleService.isEnabled('MAPPED_MODE');
    var posDefault = $scope.filterData && $scope.filterData.poses[0] === 'Default';
    if (mappedMode && posDefault) {
      return ['userRegularAggregateShare', 'userMappedAggregateShare'];
    } else if (mappedMode) {
      return ['userRegularAggregateShare'];
    } else {
      return ['userMappedAggregateShare'];
    }
  }
  function getUserValues(userData) {
    return _.chain(userData).filter(function (d) {
      return d.value !== undefined;
    }).transform(function (result, item) {
      result[item.groupId] = item.value;
      return result;
    }, {}).value();
  }
  function getProcessingChunkKey(item) {
    return item.classGroup + '-' + item.departureDate + '-' + item.significantPOS;
  }
  function prepareEffectiveValues() {
    var processingChunks = _.chain($scope.serviceShare.model).uniqBy(getProcessingChunkKey).map(getProcessingChunkKey).value();
    return _.reduce(processingChunks, function (effValues, processingChunkKey) {
      var filteringFunction = function filteringFunction(item) {
        return getProcessingChunkKey(item) === processingChunkKey;
      };
      var filteredModelValues = _.filter($scope.serviceShare.model, filteringFunction);
      var filteredUserValues = _.filter($scope.serviceShare.user, filteringFunction);
      return _.concat(effValues, effectiveValueCalculator.calculate(filteredModelValues, filteredUserValues));
    }, []);
  }
  function preparePayload() {
    var effectiveValues = prepareEffectiveValues();
    var fields = fieldsToModify();
    return _.map(fields, function (fieldName) {
      return {
        userValues: getUserValues(effectiveValues),
        matchingField: 'serviceClassId',
        field: fieldName
      };
    });
  }
  $scope.onCompareClick = function () {
    if ($scope.compareMode) {
      transitionDataService.put('service-demand-analysis', preparePayload());
      $rootScope.$broadcast('market-product-group:goToServiceTab');
      basicModeState();
      closeDrawer();
    } else {
      $scope.compareMode = true;
      $scope.compareGroupShareUserData = _.cloneDeep($scope.groupShareData.user);
      $scope.chartInCompareMode = $scope.current.chart;
      adjustButtonsAvailability();
      $rootScope.$broadcast('demand-adjustment:resetAndDisableNonCompareModeChart', $scope.current.chart);
    }
  };
  $scope.onRevertClick = function () {
    adjustButtonsAvailability();
    $scope.groupShareData.user = _.cloneDeep(getCurrentModeBaseData());
  };
  $scope.$watch('groupShareData', function () {
    var groupShareData = $scope.groupShareData;
    if (groupShareData !== undefined) {
      adjustButtonsAvailability();
      distributeUserValueService.distribute(groupShareData.user, $scope.serviceShare);
      groupShareData.effective = effectiveValueCalculator.calculateAndGroupBy($scope.serviceShare.model, $scope.serviceShare.user);
    }
  }, true);
  $scope.resetAndDisableNonCompareModeModel = function (event, tabToReset) {
    if (tabToReset !== $scope.chartId && $scope.view && !$scope.view.disabled) {
      $scope.resetUserAdjustments();
    }
  };
  function compareWithUserData(data) {
    return _.isEqual($scope.groupShareData.user, data);
  }
  function getCurrentModeBaseData() {
    return $scope.compareMode ? $scope.compareGroupShareUserData : $scope.originalGroupShareUserData;
  }
  function closeDrawer() {
    $scope.$emit('grid:hideDrawer');
  }
  $scope.isOtherChartInCompareMode = function (chartId) {
    return $scope.chartInCompareMode !== null && $scope.chartInCompareMode !== chartId;
  };
  function adjustButtonsAvailability() {
    $scope.revertButtonDisabled = compareWithUserData(getCurrentModeBaseData());
    $scope.compareButtonDisabled = compareWithUserData($scope.originalGroupShareUserData) || $scope.isOtherChartInCompareMode($scope.chartId);
  }
};
MarketAnalysisDemandAdjustmentItemController.$inject = ['$scope', '$rootScope', 'FeatureToggleService', 'TransitionDataService', 'ServiceShareDataProviderService', 'DataLoaderPanelConstants', 'DistributeUserValueService', 'EffectiveValueCalculatorService', 'UserSecureService'];
module.exports = MarketAnalysisDemandAdjustmentItemController;